import React from "react";
import MediaQuery from "react-responsive";
import TopicCard from './TopicCard';
import "../styles/CardStyles.css";
import "../styles/ResearchPage.css";

function OurResearch() {
  const card1 = (
    <TopicCard
      name="Resources"
      image={require("../images/__assets__/Resources.jpg")}
      colour="#131421"
      desc="Aim: To research the different categories biomass resources that can be used as feedstocks to fuel bioenergy technologies. In the UK key resource opportunities for the bioenergy sector include waste materials and specifically grown energy crops. The focus of our research is to explore different options to supply resources to the bioenergy sector without negatively impacting food production and maximising local environmental and global climate benefits."
      link="https://www.supergen-bioenergy.net/research/resources/"
      people={{
        "Led by:": "1596724434594-18c8e83ad",
        "Supported by:": "1596726539079-f0e6f68a",
      }}
    />
  );
  const card2 = (
    <TopicCard
      name="Pre-treatment and conversion"
      image={require("../images/__assets__/Conversion.jpg")}
      colour="#7E3D15"
      desc="Aim: To research and develop different technologies that convert biomass resources into bio-products, biofuels and bioenergy. The Topic Group has three core themes focusing on bioenergy feedstock pre-treatment processes, catalysis conversion and pyrolysis conversion technologies."
      link="https://www.supergen-bioenergy.net/research/pre-treatment-and-conversion/"
      people={{
        "Pre-treatment led by:": "1596726673282-1cae84b8c",
        "Catalysis led by:": "1596726873017-197a634c2",
        "Pyrolysis led by:": "1596725770763-1607d483b",
        "Supported by:": "1596726090359-100d53951",
      }}
    />
  );
  const card3 = (
    <TopicCard
      name="Vectors"
      image={require("../images/__assets__/Vectors.jpg")}
      colour="#4D0E0E"
      desc="Aim: To analyse the changing bio-product, biofuels and bioenergy requirements of the UK, and assess the extent that the UK bioenergy sector can balance these demands. The focus of the Topic Group is to identify the optimal bioenergy technology options for producing energy and products taking consideration the environment, economic and social performances."
      link="https://www.supergen-bioenergy.net/research/vectors/"
      people={{
        "Led by:": "1596727159702-2474844b1",
        "Supported by:": "1596117144536-587afa5e",
      }}
    />
  );
  const card4 = (
    <TopicCard
      name="Systems"
      image={require("../images/__assets__/Systems.jpg")}
      colour="#1A4517"
      desc="Aim: To assess the wider role and sustainability of bioenergy and how bioenergy systems may be developed to complement broader energy systems and related sectors. The focus of the Topic Group is to explore the potential impact and benefits of bioenergy systems on the energy trilemma - affordability, resilience and carbon reduction."
      link="https://www.supergen-bioenergy.net/research/systems/"
      people={{
        "Led by:": "1596727247411-1564eaefd",
        "Supported by:": "1597050847873-1cc68d6cf",
      }}
    />
  );

  return (
    <>
      <MediaQuery minWidth={800}>
        <div className="doubleCardColumnHome">
          {card1}
          {card2}
          {card3}
          {card4}
        </div>
      </MediaQuery>
      <MediaQuery maxWidth={799}>
        <div className="singleCardColumnHome">
          {card1}
          {card2}
          {card3}
          {card4}
        </div>
      </MediaQuery>
    </>
  );
}

export default OurResearch;
